module.exports = __webpack_public_path__ + "img/money.a0a603c9.png";